import Api from '../Api'

class Task extends Api {
  constructor(patientUuid) {
    super()

    this.patientUuid = patientUuid
  }

  weekly(year, week) {
    const path = year && week ? `weekly/${year}/${week}` : 'weekly'

    return this.request(`${this.url}/${path}`, 'GET')
  }

  completed() {
    return this.request(`${this.url}/completed`)
  }

  get url() {
    return `/patients/${this.patientUuid}/tasks`
  }
}

export default Task
